import { render, staticRenderFns } from "./wsSidebarWindowHeader.vue?vue&type=template&id=8881c944&scoped=true&"
import script from "./wsSidebarWindowHeader.vue?vue&type=script&lang=js&"
export * from "./wsSidebarWindowHeader.vue?vue&type=script&lang=js&"
import style0 from "./wsSidebarWindowHeader.vue?vue&type=style&index=0&id=8881c944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8881c944",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VHover,VIcon})
